
<template>
  <!-- <div class="main">
   <img v-default-img src="../img/sbtj.jpg" alt="">
</div> -->
  <div class="content alarmCensus" ref="tableBox" id="tableBox">
    <el-tabs
      class="tabLv3"
      type="border-card"
      v-model="tabName"
      :style="{
        position: 'static',
      }"
    >
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 设备统计
        </span>
        <div class="normalNav zaddBtn">
          <button class="BlueSmBtn" @click="search">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn download_two" @click="download2">
            导出
          </button>
        </div>
        <div class="searchForm1">
          <el-form ref="formData" :model="formData" :class="className">
            <el-form-item label="应用系统">
              <el-select
                v-model="formData.system"
                placeholder="请选择"
                @change="bindSystem"
              >
                <el-option
                  v-for="item in systemArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域">
              <el-input
                placeholder="请选择区域"
                v-model="formData.curAreaName"
                @focus="changeAreaMode(1)"
              ></el-input>
            </el-form-item>

            <el-form-item label="展示类型">
              <el-select
                v-model="formData.chart"
                placeholder="请选择"
                @change="bindchart"
              >
                <el-option
                  v-for="item in chartArr"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <template>
              <span class="collapseIcon" @click="className = 'expand'"
                ><img v-default-img :src="require('public/searchForm/collapse.png')" alt=""
              /></span>
              <span class="expandIcon" @click="className = 'collapse'"
                ><img v-default-img :src="require('public/searchForm/expand.png')" alt=""
              /></span>
            </template>
          </el-form>
        </div>
        <div class="detailtab">
          <div class="leftBar">
            <bar
              v-if="showBar"
              :chartData="chartData"
              :tableCalcul="tableCalcul"
              :flag="3"
            ></bar>
            <line-chart
              v-if="showLine"
              :chartData="chartData"
              :tableCalcul="tableCalcul"
              :flag="3"
            ></line-chart>
          </div>
          <div class="rightTable">
            <right-table
              :listData="listData"
              :items="items"
              :flag="3"
              :tableCalcul="tableCalcul"
            >
            </right-table>
          </div>
        </div>
        <mountPoint
          :hasChildNodes="areaTreeMode"
          :dialogVisible="areaTreeVisible"
          @regionTreeClose="areaTreeVisible = false"
          @regionTreeData="selRegionData"
        ></mountPoint>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";
export default {
  components: {
    normalNav: () => import("public/normalNav"),
    rightTable: () => import("./rightTable"),
    bar: () => import("./bar"),
    lineChart: () => import("./lineChart"),
    mountPoint: () => import("public/mountPoint"),
  },
  data() {
    return {
      tabName: "jsgl",
      formData: {
        system: "",
        areaId: "",
        curAreaName: "",
        // time: "",
        chart: "条形图",
      },
      systemArr: [],
      areaArr: [],
      deviceArr: [],
      className: "collapse",
      listData: [],
      items: [
        {
          prop: "systemName",
          label: "应用系统",
        },
        {
          prop: "typeName",
          label: "设备类型",
        },
        {
          prop: "amount",
          label: "设备数",
        },
      ],
      chartData: { xData: [], seriesData: [] },
      showChart: false,
      // chartArr: [{ name: "面积图" }, { name: "条形图" }],
      chartArr: [{ name: "条形图" }],
      showLine: false,
      showBar: false,
      tableCalcul: "",
      mountPoint: () => import("public/mountPoint"),
      //区域树是否显示
      areaTreeVisible: false,
      inputReadOnly: false,
      //区域树模式选择
      areaTreeMode: true,
      //选择区域树模式 查询 ？ 新增 ？
      areaMode: 1,
    };
  },
  created() {},
  mounted() {
    this.getSystem();
  },
  methods: {
    bindchart() {
      if (this.formData.chart == "面积图") {
        this.showLine = true;
        this.showBar = false;
      } else {
        this.showLine = false;
        this.showBar = true;
      }
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true;
      if (mode === 1) this.areaTreeMode = true;
      if (mode === 2) this.areaTreeMode = false;
      this.areaMode = mode;
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode;
      if (mode === 1) {
        this.formData.areaId = a.id;
        this.formData.curAreaName = a.name;
      }
    },
    bindSystem() {},
    search() {
      let data = this.formData;
      this.$axiosget("operation/deviceCountApi/getDeviceCountList", {
        params: {
          systemId: data.system,
          areaId: data.areaId,
        },
      }).then((res) => {
        this.listData = res.data.data;
        this.getData(this.listData);
      });
    },
    reset() {
      this.formData = {
        system: "",
        areaId: "",
        chart: "面积图",
      };
    },
    getData(data) {
      this.chartData = { xData: [], seriesData: [] };
      data.forEach((element) => {
        this.chartData.xData.push(element.typeName);
        // this.chartData.xData.push(element.typeName + " " + element.systemName);
        this.chartData.seriesData.push(element.amount);
      });
      let coumt;
      coumt = this.chartData.seriesData.reduce(function (total, num) {
        return total + num;
      }, 0);
      let numberOne = isNaN(coumt / this.chartData.seriesData.length)
        ? 0
        : coumt / this.chartData.seriesData.length;
      // 总计和平均值
      this.tableCalcul = [coumt.toFixed(2), numberOne.toFixed(2)];
      // this.chartData.xData = this.chartData.xData.map(function(str) {
      //   return str.replace(" ", "\n");
      // });
      if (this.formData.chart == "面积图") {
        this.showLine = true;
        this.showBar = false;
      } else {
        this.showLine = false;
        this.showBar = true;
      }
    },
    download2() {
      let data = this.formData;
      this.$axios
        .post(
          process.env.API_HOST +
            "operation/deviceCountApi/export/exportDeviceCount?" +
            "companyId=" +
            localStorage.getItem("companyId") +
            "&userId=" +
            this.$store.state.user.id +
            "&systemId=" +
            data.system +
            "&areaId=" +
            data.areaId
        )
        .then((res) => {
          // //console.log(res);
        });
    },
    getSystem() {
      let p1 = this.$axiosget(
        "manager/operatingSystemApi/getOperatingSystemsByCompanyId?compayId=".concat(
          localStorage.getItem("companyId")
        )
      );
      let p2 = this.$axiosget(
        "operation/area/selectByUserId?userId=".concat(
          this.$store.state.user.id
        )
      );
      let p3 = this.$axiosget("operation/deviceCountApi/getDeviceCountList");
      Promise.all([p1, p2, p3]).then((res) => {
        let dataArr = JSON.parse(JSON.stringify(res));
        this.systemArr = dataArr[0].data.data;
        this.areaArr = dataArr[1].data.data;
        this.listData = dataArr[2].data.data;
        this.getData(this.listData);
      });
    },
  },
};
</script>

<style scoped lang="less">
.download_two {
  background: #6f67b9;
}
.main {
  width: 100%;
  height: 100%;
  padding-top: 0 !important;
  img {
    width: 100%;
  }
}
.detailtab {
  background-color: #181c2e;
  display: flex;
  width: 100%;
  height: calc(100% - 73px);
  padding-top: 20px;
  .rightTable {
    width: 520px;
    height: 100%;
    background-color: #232944;
  }
  .leftBar {
    flex: 1;
    position: relative;
    margin-right: 20px;
  }
}
</style>
<style lang='less'>
.alarmCensus .el-tabs,
.alarmCensus .el-tabs .content,
.alarmCensus .el-tabs .el-tabs__content .el-tab-pane {
  height: 100%;
}
.alarmCensus .el-tabs .el-tabs__content {
  height: calc(100% - 52px);
}
.boxs .alarmCensus {
  height: 100%;
  padding: 0 0 43px 0;
  /* background-color: #181c2e; */
}
.alarmCensus .el-form .el-form-item .el-form-item__content {
  width: calc(100% - 100px);
  .el-date-editor {
    width: calc(100%);
  }
  .el-range-input {
    background: #2e3657;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/reportForms/deviceStatistics.vue